module.exports = __webpack_public_path__ + "img/t_price.b4bb4726.png";